import { render, staticRenderFns } from "./VizualizarPedido.vue?vue&type=template&id=78dea7c1"
import script from "./VizualizarPedido.vue?vue&type=script&lang=js"
export * from "./VizualizarPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports